<template>
  <div>
    <LeftSidebar
      :visible="visible"
      :title="$lang.historyBehavioralWitness"
      bodyClass="padding-y-16 overflow-y-hidden"
      titleClass="padding-x-16"
      :hasBack="false"
      :hasFooter="false"
      @close="handleClose"
    >
      <template>
        <ListWrapper
          v-if="visible"
          :url="url"
          :hasTitle="false"
          :hasAddButton="false"
          :isUseInSidebar="true"
          menuBarClass="padding-x-16"
          searchTxtClass="width-percent-100"
          @getPermissions="getPermissions"
          @getLoading="getLoading"
        >
          <template slot-scope="{ items }">
            <LoadingWrapper :loading="loading">
              <template #loading>
                <Loading :count="10" />
              </template>
              <template #default>
                <b-row class="margin-0 padding-x-16">
                  <b-col
                    v-for="(item, index) in generateItems(items)"
                    :key="index"
                    cols="12"
                    class="border--solid border--complementary-50 border-radius-8 padding-x-12 padding-y-8 margin-bottom-8"
                  >
                    <div>
                      <span class="font-size-12 color-complementary-300">
                        {{ $lang.createdAt }}:
                      </span>
                      <span
                        class="font-size-14 color-complementary-400"
                        v-html="item.createdAt"
                      ></span>
                    </div>

                    <div>
                      <span class="font-size-12 color-complementary-300">
                        {{ $lang.createdBy }}:
                      </span>
                      <span class="font-size-14 color-complementary-400">
                        {{ item.createdBy }}
                      </span>
                    </div>
                    <div>
                      <span class="font-size-12 color-complementary-300">
                        {{ $lang.userExecutiveRole }}:
                      </span>
                      <span class="font-size-14 color-complementary-400">
                        {{ item.userExecutiveRole }}
                      </span>
                    </div>
                    <div>
                      <span class="font-size-12 color-complementary-300">
                        {{ $lang.behavioralWitness }}:
                      </span>
                      <span class="font-size-14 color-complementary-400">
                        {{ item.behavioralWitness }}
                      </span>
                    </div>
                  </b-col>
                </b-row>
              </template>
            </LoadingWrapper>
          </template>
        </ListWrapper>
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import {
  LeftSidebar,
  ListWrapper,
  LoadingWrapper,
} from "@/components/re-design";
import Loading from "./Loading.vue";
import { computed, ref, toRefs } from "vue";
import { pathOr } from "ramda";
import { createDateFormat, generateApiUrl } from "@/shared/utils";

export default {
  components: { LeftSidebar, ListWrapper, LoadingWrapper, Loading },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    evidenceId: {
      type: [Number, String],
      default: null,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { visible, evidenceId } = toRefs(props);

    const handleClose = () => emit("handleClose");

    const url = computed(() =>
      generateApiUrl(["kanoon", "evidenceHistoryLog"], [evidenceId.value])
    );

    const permissions = ref([]);
    const getPermissions = (value) => (permissions.value = [...value]);

    const loading = ref(false);
    const getLoading = (value) => (loading.value = value);

    // regenerate items with custom format
    const generateItems = (items) => {
      return items.map((item) => {
        return {
          id: false,
          createdAt: createDateFormat(
            pathOr("", ["created_at", "jalali"], item)
          ),
          createdBy: pathOr("", ["created_by"], item),
          userExecutiveRole: pathOr(
            "",
            ["user_executive_role", "caption"],
            item
          ),
          behavioralWitness: pathOr("", ["sample"], item),
        };
      });
    };

    // return data to be used in template
    return {
      visible,
      url,
      handleClose,
      getPermissions,
      loading,
      getLoading,
      generateItems,
    };
  },
};
</script>
